import { SxProps, Theme } from "@mui/material/styles";
import { gris2 } from "../../theme";

const styles: SxProps<Theme> = [
  {
    "&.containerDialog": {
      display: "flex",
      alignItems: "center",
    },
    "& .iconButton": {
      padding: 0,
      marginRight: "12px",
      position: "absolute",
      right: 0,
      top: 7,
      color: gris2,
      "&:hover": {
        background: "transparent",
        color: "#000",
      },
    },
    "& .closeButton": {
      "&:hover": {
        background: "transparent",
        color: "#000",
      },
    },
  },
];

export default styles;
